import React, { useEffect } from "react";
import { motion, useAnimation } from "framer-motion";

export default function Timeline({
  duration = 0,
  enabled = false,
  onEnd = () => {},
  onClick = () => {},
  className = "",
}) {
  const timelineControls = useAnimation();

  useEffect(() => {
    if (!enabled || duration === 0) {
      timelineControls.stop();
    } else {
      timelineControls.start(
        {
          width: 0,
          backgroundColor: ["#1cf28c", "#f4cb23", "#d40a1e"],
        },
        { duration: duration, delay: 0.5 }
      );
    }
  }, [timelineControls, enabled, duration]);

  return (
    <motion.div
      onClick={onClick}
      className={className}
      initial={{
        backgroundColor: "#1cf28c",
      }}
      animate={timelineControls}
      onAnimationComplete={() => {
        if (enabled && typeof onEnd === "function") {
          onEnd();
        }
      }}
    />
  );
}
